import { Moment } from 'moment';
import { SituationOptions } from '../workOrders/WorkOrderReport.types';

export enum DateFilterByTypes {
  entry = 'Entry',
  authorization = 'Authorization',
  closing = 'Closing',
  leave = 'Leave',
}

export enum TypeReportTypes {
  DATE = 'DATE',
  EMPLOYEE = 'EMPLOYEE',
  CUSTOMER = 'CUSTOMER',
  VEHICLE = 'VEHICLE',
}

export enum FormatType {
  PDF = 'PDF',
  CSV = 'CSV',
}

export interface DailyMovementRequest {
  //----------ReportSelectMonthFields----------
  companiesIds?: string;
  startDate?: string;
  endDate?: string;
  //------------------others-------------------
  NCM: number;
  subGroupIds: string;
  customersIds: string;
  estimatorIds: string;
  typeReport: TypeReportTypes;
  dateFilterBy: DateFilterByTypes;
  format: FormatType;
  //-----------------Situation-----------------
  open: boolean;
  authorized: boolean;
  closed: boolean;
  canceled: boolean;
  //-----------------checkbox------------------
  parts: boolean;
  suppliedParts: boolean;
  services: boolean;
  thirdParty: boolean;
  directSale: boolean;
  summary: boolean;
}

export interface DailyMovementRequestForm {
  //----------ReportSelectMonthFields----------
  finalDate: Moment;
  initialDate: Moment;
  companiesIds: number[];
  //------------------others-------------------
  NCM: number;
  subGroupIds: number[];
  customerIds: number[];
  estimatorIds: number[];
  situation: SituationOptions;
  typeReport: TypeReportTypes;
  dateFilterBy: DateFilterByTypes;
  //-----------------checkbox------------------
  parts: boolean;
  summary: boolean;
  services: boolean;
  thirdParty: boolean;
  directSale: boolean;
  suppliedParts: boolean;
}
